// extracted by mini-css-extract-plugin
export default {"link":"ForgotPassword_link__L2Iym","success":"ForgotPassword_success__LHaxx"};